import styled from 'styled-components'

export const FullPageWrapper = styled.div`
  background-color: #fff;
  color: #1a1a1a;
  font-family: 'Roboto', system-ui, sans-serif;

  width: 100%;
  min-height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 24px;
`

export const Box = styled.div`
  width: 100%;
  max-width: 480px;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Logo = styled.img`
  max-height: 40px;
  width: auto;
  margin-bottom: 30px;
`

export const Title = styled.h1`
  font-size: 1.4rem;
  font-weight: 600;
  margin: 0 0 8px 0;
  text-align: center;
  color: #1a1a1a;
`

export const Subtitle = styled.p`
  font-size: 0.95rem;
  line-height: 1.4;
  color: #6b6b6b;
  text-align: center;
  margin: 0 0 24px 0;

  strong {
    color: #1a1a1a;
  }
`

export const OtpRow = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
`

export const OtpInput = styled.input`
  width: 56px;
  height: 56px;
  text-align: center;
  font-size: 1.2rem;

  border: 1px solid #e1e1e1;
  border-radius: 12px;
  background-color: #ededed;
  color: #1a1a1a;

  &:focus {
    outline: none;
    border-color: #007dc9;
    box-shadow: 0 0 0 3px rgba(0, 125, 201, 0.15);
  }

  @media (max-width: 420px) {
    width: 48px;
    height: 48px;
  }
`

export const ContinueButton = styled.button<{ disabled?: boolean }>`
  width: 100%;
  height: 44px;
  border: 0;
  border-radius: 24px;
  background-color: #007dc9;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;

  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  &:hover {
    filter: brightness(0.95);
  }

  &:active {
    filter: brightness(0.9);
  }

  margin-bottom: 16px;
`

export const HelpRow = styled.div`
  color: #6b6b6b;
  font-size: 0.95rem;
  margin-bottom: 16px;
  text-align: center;
`

export const ResendLink = styled.button`
  border: 0;
  background: none;
  padding: 0;
  margin-left: 6px;
  color: #0072ce;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`

export const BackRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0072ce;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`

export const BackIcon = styled.span`
  line-height: 1;
`

export const BackText = styled.span`
  line-height: 1;
`
